import { render, staticRenderFns } from "./ExtraFieldTextOptionsMetaDataAutocomplete.vue?vue&type=template&id=3f956c76"
import script from "./ExtraFieldTextOptionsMetaDataAutocomplete.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldTextOptionsMetaDataAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f956c76')) {
      api.createRecord('3f956c76', component.options)
    } else {
      api.reload('3f956c76', component.options)
    }
    module.hot.accept("./ExtraFieldTextOptionsMetaDataAutocomplete.vue?vue&type=template&id=3f956c76", function () {
      api.rerender('3f956c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldTextOptionsMetaDataAutocomplete.vue"
export default component.exports